<template>
  <a-row :gutter="24">
    <a-col :span="24">
      <div style="width: 80%; margin: auto; line-height: 26px">
        <a-form-model-item
          prop="transactionModeType"
          label="招租方式类型"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 16 }"
        >
          <div>
            <a-radio-group v-model="form.transactionModeType">
              <a-radio style="margin: 4px 0px" :value="1">竞价</a-radio>
              <a-radio style="margin: 4px 0px" :value="2">择优遴选</a-radio>
              <a-radio style="margin: 4px 0px" :value="3">其他竞价</a-radio>
            </a-radio-group>
          </div>
        </a-form-model-item>
      </div>
    </a-col>

    <a-col :span="24">
      <div style="width: 80%; margin: auto; line-height: 26px">
        <a-form-model-item
          prop="transactionMode"
          label="招租方式"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 16 }"
        >
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <span>
              <a-radio-group v-model="form.transactionMode">
                <a-radio
                  v-if="form.transactionModeType == 1"
                  style="margin: 4px 0px"
                  :value="1"
                  >网络竞价</a-radio
                >
                <a-radio
                  v-if="form.transactionModeType == 2"
                  style="margin: 4px 0px"
                  :value="2"
                  >权重报价</a-radio
                >
                <a-radio
                  v-if="form.transactionModeType == 3"
                  style="margin: 4px 0px"
                  :value="4"
                  >其他竞价</a-radio
                >
                <a-radio
                  v-if="form.transactionModeType == 1"
                  style="margin: 4px 0px"
                  :value="5"
                  >开放报价</a-radio
                >
                <!-- <a-radio style="margin: 4px 0px" :value="6">协议转让</a-radio> -->
                <a-radio
                  v-if="form.transactionModeType == 2"
                  style="margin: 4px 0px"
                  :value="7"
                  >竞争性谈判</a-radio
                >
              </a-radio-group>
            </span>
            <span
              v-if="form.transactionModeType == 1 && form.transactionMode == 1"
              style="color: #007aff"
            >
              <a>《竞价方案须知》</a>
              <a>《报价人操作指南》</a>
            </span>
          </div>
        </a-form-model-item>
      </div>
    </a-col>

    <a-col :span="24">
      <div style="width: 80%; margin: auto; line-height: 26px">
        <a-form-model-item
            prop="hasQualificationAudit"
          label="出租方是否对意向承租方进行资格审核"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 16 }"
        >
          <div>
            <a-radio-group v-model="form.hasQualificationAudit" :disabled="form.transactionModeType == 1 && form.transactionMode == 5">
              <a-radio style="margin: 4px 0px" :value="1">是</a-radio>
              <a-radio style="margin: 4px 0px" :value="0">否</a-radio>
            </a-radio-group>
          </div>
        </a-form-model-item>
      </div>
    </a-col>

    <a-col
      :span="24"
      v-if="form.transactionModeType == 1 && form.transactionMode == 1"
    >
      <div style="width: 80%; margin: auto; line-height: 26px">
        <a-form-model-item
          prop="onlineBiddingMode"
          label="网络竞价模式"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 16 }"
        >
          <div>
            <a-radio-group v-model="form.onlineBiddingMode">
              <a-radio style="margin: 4px 0px" :value="1">多次报价</a-radio>

              <a-radio style="margin: 4px 0px" :value="2">一次报价</a-radio>
            </a-radio-group>
          </div>
        </a-form-model-item>
      </div>
    </a-col>

    <a-col
      :span="24"
      v-if="form.transactionModeType == 3 && form.transactionMode == 4"
    >
      <div style="width: 80%; margin: auto; line-height: 26px">
        <a-form-model-item
          prop="otherBidDesc"
          label="其他竞价说明"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-textarea
          v-model="form.otherBidDesc"
          placeholder="请输入其他竞价说明"
          :rows="1"
        />
        </a-form-model-item>
      </div>
    </a-col>
  </a-row>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
  },
};
</script>

<style>
</style>